import { Icon, IconProps, Link } from '@cloudscape-design/components';
import { useTranslate } from 'src/i18n/useTranslate';
import InfoPageTemplate from 'src/templates/info-page-template/info-page-template';
import { CONTACT_LINK } from 'src/utils/constants';
import { useLocation, useNavigate } from 'react-router-dom';
import { MaintenanceStatus } from 'src/types/maintenanceStatus';

import './maintenance-page.scss';

type MaintenanceProps = {
    maintenanceStatus: MaintenanceStatus;
};

const MaintenancePage = ({ maintenanceStatus }: MaintenanceProps) => {
    const t = useTranslate();
    const navigate = useNavigate();
    const state = useLocation().state as MaintenanceStatus;

    const status = state ?? maintenanceStatus;
    const buttonProps = {
        iconName: 'refresh' as IconProps.Name,
        onClick: () => navigate(-1),
        text: 'Refresh Page',
    };

    const getEstimatedDefaultTime = () => {
        const date = new Date();
        date.setMinutes(date.getMinutes() + 30);
        // Remove any seconds to get a round number
        date.setSeconds(0);
        return date.toLocaleString();
    };

    const formatEndDate = () => {
        if (status.expectedEndTime) {
            const date = new Date(status.expectedEndTime);
            date.setSeconds(0);
            return date.toLocaleString();
        }
        return undefined;
    };

    return (
        <InfoPageTemplate
            headerText={t('maintenance_header', 'System Maintenance')}
            icon={
                <Icon
                    ariaLabel={t('status_info', 'status-info')}
                    name="status-info"
                    size="inherit"
                    variant="warning"
                />
            }
            buttonProps={buttonProps}
        >
            <div className={'maintenance-info'}>
                {t(
                    'maintenance_detail',
                    'The system is currently undergoing scheduled maintenance.'
                )}
            </div>
            <div className={'maintenance-info'}>
                {t(
                    'maintenance_estimated_completion_time',
                    'Estimated time of completion: '
                )}
                {`${formatEndDate() || getEstimatedDefaultTime()} `}
            </div>
            <div className={'maintenance-info'}>
                {t(
                    'maintenance_contact_us_prefix',
                    'If you need immediate assistance, please '
                )}
                <Link href={CONTACT_LINK} target="_blank">
                    {t('contact_us', 'contact us')}
                </Link>
            </div>
        </InfoPageTemplate>
    );
};

export default MaintenancePage;
